module.exports = __webpack_public_path__ + "static/img/fourth.2410c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/solution/fourth.png
// module id = dG8q
// module chunks = 1